var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-TEASER" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                !_vm.gettingABTnR &&
                !_vm.teaserGroups.length &&
                _vm.currentBetSlipState <= 1,
              expression:
                "!gettingABTnR && !teaserGroups.length && currentBetSlipState<=1"
            }
          ],
          staticClass: "info msg all_corners"
        },
        [
          _c("v-icon", [_vm._v("info_outline")]),
          _vm._v(" "),
          _c("span", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("BetSlip.tab.TEASER.emptyInfoMsg"))
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._l(_vm.teaserGroups, function(group, index) {
        return _c("teaser", {
          key: group.id,
          attrs: {
            index: index,
            groupId: _vm.useSelectionTeaserInfos ? group.id : group.idFoSport,
            groupIdFoSport: group.idFoSport,
            group: group,
            currentBetSlipState: _vm.currentBetSlipState,
            tab: _vm.tab,
            allowedBetTypesAndReturns:
              _vm.allowedBetTypesAndReturns[
                _vm.useSelectionTeaserInfos ? group.id : group.idFoSport
              ],
            betTypeStakes: _vm.betTypeStakes,
            interRelated: _vm.interRelated,
            gettingABTnR: _vm.gettingABTnR
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7a2353e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a2353e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/tabs/tabTeaser.vue
// module id = null
// module chunks = 